import {
	Typography,
	Icon,
	ListItem,
	Stack,
	Grid,
	Tooltip,
	Chip,
} from '@mui/material';

import { useState } from 'react';

import { useSelector } from 'react-redux';

import moment from 'moment';

import { ReactComponent as CloseIcon } from 'common/assets/images/close.svg';
import { ReactComponent as CorrectTickIcon } from 'common/assets/images/correct-tick.svg';
import { ReactComponent as DeleteIcon } from 'common/assets/images/delete-icon.svg';
import { ReactComponent as DrawerClose } from 'common/assets/images/drawer-close.svg';
import { ReactComponent as EditIcon } from 'common/assets/images/edit-pencil.svg';
import { ReactComponent as Loading } from 'common/assets/images/loader.svg';
import { ReactComponent as SaveIcon } from 'common/assets/images/save-ai-icon.svg';
import { ReactComponent as WarningIcon } from 'common/assets/images/warning.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import ModalEle from 'common/components/Modal/ModalEle';
import TextFieldComponent from 'common/components/TextField/TextField';
import { APP_ASK_RISK_LINK_CHAT_HISTORY_NOTIFICATION } from 'common/constants/TextContent';
import { dateFormatForGPT } from 'common/utils/utilFunctions';

import { IChatHistory, IKnowledgeBaseOptions } from '../api/type-def';

import SaveChatModal from './SaveChat/SaveChatModal';

import style from './GroupChatSession.module.scss';

interface GroupchatSessionProps {
	data: IChatHistory;
	handleSelectChatHistory: (id: string, knowledgeBase: string) => void;
	handleDeleteChatHistory: (id: string) => void;
	updateChatHistoryName: (chartId: string, histroyName: string) => void;
	editClick: string;
	setEditClick: (id: string) => void;
}

const GroupChatSession = (props: GroupchatSessionProps) => {
	const {
		data,
		handleSelectChatHistory,
		editClick,
		setEditClick,
		updateChatHistoryName,
		handleDeleteChatHistory,
	} = props;
	const {
		actionIconFillColor,
		waringIconFillColor,
		drawerCloseIconColor,
		drawerDeleteHeaderColor,
	} = style;

	const [selectedIndex, setSelectedIndex] = useState<string>('');
	const [hoverIcon, setHoverIcon] = useState<boolean>(false);
	const [histroyName, setHistoryName] = useState<string>(data.name);
	const [deleteModelFlag, setDeleteModelFlag] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const riskGPTKnowledgeOptions: IKnowledgeBaseOptions[] = useSelector(
		(state: any) => state.common.riskGptKnowledgeBaseOptions,
	);
	const [showSaveModal, setShowSaveModal] = useState(false);
	const itemDate = moment(
		data.updatedAt ? data.updatedAt : data.createdAt,
	).endOf('day');
	const today = moment().endOf('day');
	const differenceInDays = today.diff(itemDate, 'days');
	const thirtyDays = 30;

	const saveHandler = () => {
		setShowSaveModal(true);
	};

	const onChangeValue = (e: any) => {
		setHistoryName(e.target.value);
	};

	const setListHover = (index: string) => {
		setHoverIcon(true);
		setSelectedIndex(index);
	};

	const onHideListIcons = () => {
		setHoverIcon(false);
	};

	const saveHistoryName = () => {
		if (histroyName) {
			setIsLoading(true);
			updateChatHistoryName(data.id, histroyName);
		}
	};

	const onCancelChangeName = () => {
		setHistoryName(data.name);
		setEditClick('');
	};

	const handleModalClose = () => {
		setDeleteModelFlag(false);
	};

	const sxBoxProps = { width: '33rem', height: '27.5rem' };

	const getChipLabel = (sessionType: string) => {
		if (riskGPTKnowledgeOptions.length > 0) {
			return (
				riskGPTKnowledgeOptions.find((ele) => ele.value === sessionType)
					?.label || ''
			);
		}
		return '';
	};
	return (
		<div className={style['recent-data-container']}>
			<ListItem
				className={style['recent-data-container']}
				data-testid="list-actions"
				onMouseMove={() => {
					setListHover(data.id);
				}}
				onMouseOut={() => {
					onHideListIcons();
				}}
				onBlur={() => {
					onHideListIcons();
				}}
			>
				{editClick === data.id ? (
					<>
						<TextFieldComponent
							fullWidth
							inputProps={{
								'data-testid': 'chathistory-name',
							}}
							type="text"
							name="chatHistpryName"
							value={histroyName}
							onChange={(e) => onChangeValue(e)}
							className={style['recent-data-wording-textbox']}
							placeholder="Enter history name"
						/>
						<Stack direction="row" className={style['recent-data-action']}>
							{isLoading ? (
								<Icon className={style['icon-style']}>
									<Loading />
								</Icon>
							) : (
								<>
									<Icon
										className={
											histroyName === ''
												? style['icon-style-disable']
												: style['icon-style']
										}
									>
										<CorrectTickIcon
											data-testid="edit-icon-tick"
											onClick={saveHistoryName}
											fill={actionIconFillColor}
										/>
									</Icon>
									<Icon className={style['icon-style']}>
										<DrawerClose
											data-testid="save-cancel-icon"
											fill={drawerCloseIconColor}
											onClick={onCancelChangeName}
										/>
									</Icon>
								</>
							)}
						</Stack>
					</>
				) : (
					<>
						<Typography
							className={style['recent-data-wording']}
							key={data.id}
							onClick={() =>
								handleSelectChatHistory(
									data.id,
									data.configuration.session_type,
								)
							}
						>
							<Tooltip title={data.name} placement="bottom-start">
								<div className={style['recent-data-wording']}>{data.name}</div>
							</Tooltip>
						</Typography>
						<Stack direction="row" className={style['recent-data-action']}>
							{hoverIcon &&
							selectedIndex === data.id &&
							editClick !== data.id ? (
								<>
									<Typography
										className={style['recent-data-wording']}
										key={data.id}
										onClick={() =>
											handleSelectChatHistory(
												data.id,
												data.configuration.session_type,
											)
										}
									>
										{dateFormatForGPT(data.updatedAt)}
									</Typography>
									<Icon className={style['icon-style']}>
										<SaveIcon
											data-testid="save-icon"
											onClick={saveHandler}
											fill={actionIconFillColor}
										/>
									</Icon>
									<Icon className={style['icon-style']}>
										<EditIcon
											data-testid="edit-icon"
											onClick={() => {
												setEditClick(data.id);
											}}
											fill={actionIconFillColor}
										/>
									</Icon>
									<Icon className={style['icon-style']}>
										<DeleteIcon
											data-testid="delete-icon"
											onClick={() => {
												setDeleteModelFlag(true);
											}}
											fill={actionIconFillColor}
										/>
									</Icon>
								</>
							) : (
								<Chip label={getChipLabel(data.configuration.session_type)} />
							)}
							{differenceInDays > thirtyDays && (
								<Tooltip
									title={APP_ASK_RISK_LINK_CHAT_HISTORY_NOTIFICATION}
									placement="left"
									data-testid="Share-tooltip"
								>
									<Icon className={style['icon-style']}>
										<WarningIcon
											data-testid="warning-icon"
											fill={waringIconFillColor}
										/>
									</Icon>
								</Tooltip>
							)}
						</Stack>
					</>
				)}
			</ListItem>

			<ModalEle
				open={deleteModelFlag}
				handleClose={handleModalClose}
				sxBoxProps={sxBoxProps}
			>
				<Stack direction="column">
					<Stack direction="row" justifyContent="space-between">
						<Typography className={style['header-text']} data-testid="header">
							Confirm Delete
						</Typography>
						<CloseIcon
							fontSize="medium"
							onClick={handleModalClose}
							className={style['add-closemodal']}
							data-testid="close-icon"
						/>
					</Stack>
				</Stack>
				<Grid container xs={12} lg={12} sm={12} md={12} direction="row">
					<Grid
						container
						item
						direction="row"
						xs={12}
						lg={12}
						sm={12}
						md={12}
						mt={2}
					>
						<Grid
							item
							xs={12}
							lg={12}
							sm={12}
							md={12}
							className={style['delete-header']}
						>
							<WarningIcon stroke={drawerDeleteHeaderColor} />
							Are you sure you want to delete?
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							sm={12}
							md={12}
							className={style['delete-sub-header']}
						>
							Once you perform this action, it cannot be reversed, and you will
							not have the ability to retrieve this Data.
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							sm={12}
							md={12}
							className={style['chat-delete-step-btngrp']}
						>
							<ButtonComp
								btnType="secondary"
								compClass={style['delete-cancel-button']}
								clickHandler={handleModalClose}
								data-testid="delete-model-cancel"
							>
								Cancel
							</ButtonComp>
							<ButtonComp
								btnType="primary"
								compClass={style['delete-button']}
								clickHandler={() => handleDeleteChatHistory(data.id)}
								data-testid="delete-model-chat"
							>
								Delete
							</ButtonComp>
						</Grid>
					</Grid>
				</Grid>
			</ModalEle>
			{showSaveModal && (
				<SaveChatModal
					handleClose={() => setShowSaveModal(false)}
					open={showSaveModal}
					sessionId={data.id}
				/>
			)}
		</div>
	);
};

export default GroupChatSession;
